<div
  class="w-[300px] bg-[#FFF7D3] p-[10px] m-2 fixed bottom-2 left-2 shadow-md rounded-md cursor-pointer"
>
  <div class="absolute top-1 right-1 cursor-pointer" (click)="popupClose()">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1.4em"
      height="1.4em"
      viewBox="0 0 512 512"
    >
      <path
        fill="none"
        stroke="#464646"
        stroke-miterlimit="10"
        stroke-width="32"
        d="M448 256c0-106-86-192-192-192S64 150 64 256s86 192 192 192s192-86 192-192Z"
      />
      <path
        fill="none"
        stroke="#464646"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="32"
        d="M320 320L192 192m0 128l128-128"
      />
    </svg>
  </div>
  <div
    class="flex gap-[10px] pt-[10px] pb-[10px]"
    (click)="performAction(data.action)"
  >
    <div class="shrink-0">
      <img [src]="data?.images?.reviewIcon" alt="review" title="review" />
    </div>
    <div class="grow">
      <div class="text-[16px] text-[#162F4D] font-semibold">
        {{ data.title }}
      </div>
      <div class="text-[#5B5B5B] text-[14px]">
        {{ data.description }}
      </div>
      <div></div>
    </div>
    <div></div>
  </div>
</div>
